import React from "react";

import { Alerta, TipoAlerta, Row, Col } from "@intechprev/componentes-web";

import { EmprestimoService } from "../../../services";
import { ContratoEntidade } from "../../../entidades";

import { Page } from "../..";
import { NumFuncionalidade } from "../../Page";
import { Prestacoes } from "./Prestacoes";
import { Dados } from "./Dados";
import { Link } from "react-router-dom";

interface Props {
  match?: any;
}

interface State {
  numero: string;
  ano: string;
  detalhes: ContratoEntidade;
  erro: string;
}

export class EmprestimoDetalhe extends React.Component<Props, State> {

  private page = React.createRef<Page>();

  constructor(props: Props) {
    super(props);

    this.state = {
      numero: props.match.params.numero,
      ano: props.match.params.ano,
      detalhes: null,
      erro: ""
    };
  }

  componentDidMount = async () => {
    await this.page.current.loading(true);
    try {
      const detalhes = await EmprestimoService.BuscarDetalhePorNumeroAno(this.state.numero, this.state.ano);

      this.setState({ detalhes });
    } catch (err) {
      const erro = err.response ? err.response.data : err;
      this.setState({
        erro: erro || "Houve um erro ao carregar o detalhamento do empréstimo. Tente novamente mais tarde."
      });
    }
    finally {
      await this.page.current.loading(false);
    }
  };

  render = () => {
    return (
      <Page Funcionalidade={NumFuncionalidade.EMPRESTIMOS_CONSULTA} {...this.props} ref={this.page}>
        {this.state.erro !== "" && <Alerta mensagem={this.state.erro} tipo={TipoAlerta.danger} />}

        {this.state.detalhes && (
          <>
            <Row className={"mb-2"}>
              <Col>
                <Link className={"btn btn-primary"} to={"/emprestimo"}>
                  Voltar
                </Link>
              </Col>
            </Row>

            <Row>
              <Col tamanho={"12"} className={"col-lg-6"}>
                <Dados detalhes={this.state.detalhes} />
              </Col>

              <Col tamanho={"12"} className={"col-lg-6"}>
                <Prestacoes prestacoes={this.state.detalhes.Prestacoes} />
              </Col>
            </Row>
          </>
        )}
      </Page>
    );
  };
}
